var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSubway = function SvgSubway(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 12,
    viewBox: "94 265 407 275",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M473.4 504.1L378 263l-80.4 140.9L217.3 263l-95.4 241.1H93.8v36.4h144.1v-36.4h-21.5l20.9-60.1 60.3 99.2 60.3-99.2 20.9 60.1h-21.5v36.4h144.1v-36.4z",
    fill: "currentColor"
  })));
};
export default SvgSubway;